export { default as ClientesTabs } from "./ClientesTabs";
